var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveDownIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#DE1186",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11V5h-1v6H8.5l3 3 3-3zM5 4v3H2V4h3zm1-1H1v5h5V3zM1 10h1.5v1H1v-1zM3 10h1.5v1H3v-1zM5 10h1v1.5H5V10zM1 13.5h1V15H1v-1.5zM2.5 14H4v1H2.5v-1zM4.5 14H6v1H4.5v-1zM1 11.5h1V13H1v-1.5zM5 12h1v1.5H5V12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDownIcon);
export default __webpack_public_path__ + "static/media/move-down-icon.e7b70ac50b4da8fbe68558c18912b5a3.svg";
export { ForwardRef as ReactComponent };